// test.js

require('../module.jsx');



//////////////////
// WEBPACK FOOTER
// ./~/jest-cli/src/__tests__/test_root/__testtests__/test.js
// module id = 1505
// module chunks = 0